import { Button, Col, Form, Input } from "antd";
import ContainerLayout from "../../common/containerLayout";
import { selectCurrentAdminPartnerFee } from "../../../utils/helpers/selectorHelper";
import { useState } from "react";
import { updateAdminPartnerFee } from "../../../services/adminApi";
import { useAppDispatch } from "../../../app/hooks";
import { updateAdminPartnerFeeValue } from "../../../features/admin/currentAdminSlice";

const AdminConfiguration = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const onHandleClick = async (values: any) => {
    const { partnerFee } = values;
    setIsLoading(true);
    await updateAdminPartnerFee(partnerFee);
    dispatch(updateAdminPartnerFeeValue(partnerFee));
    setIsLoading(false);
  };

  return (
    <ContainerLayout
      title="Configuración"
      showNotification={false}
      justify="center"
    >
      <Col span={6}>
        <Form
          form={form}
          onFinish={onHandleClick}
          initialValues={{ partnerFee: selectCurrentAdminPartnerFee() }}
          layout="vertical"
        >
          <Form.Item
            name="partnerFee"
            label="Comisión del socio"
            rules={[{ required: true, message: "Ingrese una comisión" }]}
          >
            <Input placeholder="0.0" type="number" />
          </Form.Item>
          <Button type="primary" loading={isLoading} htmlType="submit">
            Guardar
          </Button>
        </Form>
      </Col>
    </ContainerLayout>
  );
};

export default AdminConfiguration;
